import { useEffect } from 'react'

import { DEFAULT_DOCUMENT_TITLE } from '@v2/commons/constants/documentTitle'

const useDocumentTitle = (title: string | undefined) => {
  useEffect(() => {
    if (typeof document !== 'undefined') {
      document.title = title
        ? `${title} | ${DEFAULT_DOCUMENT_TITLE}`
        : DEFAULT_DOCUMENT_TITLE
    }

    return () => {
      if (typeof document !== 'undefined') {
        document.title = DEFAULT_DOCUMENT_TITLE
      }
    }
  }, [title])
}

export default useDocumentTitle
